import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, CalendarDays, CheckSquare, Settings } from 'lucide-react';
export function MobileNav() {
  const items = [{
    to: '/app/dashboard',
    icon: LayoutDashboard,
    label: 'Inicio'
  }, {
    to: '/app/leads',
    icon: Users,
    label: 'Leads'
  }, {
    to: '/app/calendario',
    icon: CalendarDays,
    label: 'Agenda'
  }, {
    to: '/app/qa',
    icon: CheckSquare,
    label: 'QA'
  }, {
    to: '/app/config',
    icon: Settings,
    label: 'Más'
  }];
  return <nav className="md:hidden fixed bottom-0 left-0 right-0 h-16 bg-growthly-surface border-t border-white/[0.04] flex z-40" data-id="element-244">
      {items.map(({
      to,
      icon: Icon,
      label
    }) => <NavLink key={to} to={to} className={({
      isActive
    }) => `flex-1 flex flex-col items-center justify-center gap-1 text-[11px] transition-colors ${isActive ? 'text-white' : 'text-growthly-muted'}`} data-id="element-245">
          <Icon size={20} strokeWidth={1.8} data-id="element-246" />
          {label}
        </NavLink>)}
    </nav>;
}